<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link class="text-decoration--none" :to="{ name: 'providers' }"
          >Providers</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <div
        v-if="provider"
        class="headline font-weight-bold my-6 text-capitalize"
      >
        {{ provider.name }}
      </div>

      <div class="d-flex my-6">
        <v-tabs hide-slider class="user-info-tabs">
          <v-tab class="pa-0" v-for="(item, key) in tabItems" :key="key">
            <h3 class="py-5 primary--text">{{ item.tab }}</h3>
          </v-tab>
          <v-tab-item class="col-md-4 col-sm-12 col-xs-12 mt-6 pa-0">
            <ProviderForm
              v-if="provider"
              :provider="provider"
              @show-snackbar="showSnackbar"
            />
          </v-tab-item>
        </v-tabs>
      </div>
    </div>
    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show = false">OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mdiChevronLeft, mdiCheck, mdiAlertCircleOutline } from '@mdi/js'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ProviderForm from './components/ProviderForm'

export default {
  name: 'ProviderDetails',

  components: {
    AppBarNavIcon,
    ProviderForm,
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
        check: mdiCheck,
        alert: mdiAlertCircleOutline,
      },
      tabItems: [{ tab: 'Provider Information' }],
      datePickerMenu: false,
      snackbar: {
        show: false,
        message: null,
        color: '',
      },
    }
  },

  computed: {
    ...mapGetters({
      provider: 'provider/providerDetails',
    }),
  },

  methods: {
    ...mapActions({
      getProviderDetails: 'provider/getProviderDetails',
    }),

    ...mapMutations({
      clearProviderDetails: 'provider/clearProviderDetails',
    }),

    async getProvider() {
      this.loading = true
      await this.getProviderDetails(this.$route.params.id)
    },

    showSnackbar(event) {
      this.snackbar.message = event.message
      this.snackbar.show = true
      this.snackbar.color = event.color
    },
  },

  created() {
    this.getProvider()
  },

  destroyed() {
    this.clearProviderDetails()
  },

  watch: {
    $route() {
      this.getProvider()
    },
  },
}
</script>

<style lang="scss" scoped>
.user-form {
  width: 400px;

  @media (max-width: 420px) {
    width: 100%;
  }
}
</style>
